// DM Screen Data - Pre-populated content for Dungeon Masters
// This file contains all the random tables and lists for the DM Screen

export const dmScreenData = {
  tavernNames: [
    "The Piss and Whistle",
    "The Setting Sun",
    "The Fishy Smell",
    "The Red Lion",
    "The Redder Lion",
    "The Hobbit Hole",
    "The Slouching Troll",
    "Ms. Mary's Mistake",
    "Fortune's Wheel",
    "The Black Gate",
    "The Shadow of the Castle",
    "The Giddy Griffin Inn and Tavern",
    "Brazen Beholder Brews and Benches",
    "The Bawdy Winch Brew Hall",
    "The Rusty Blade",
    "The Hobbled Hobgoblin's Hearth",
    "Lich Lord Libations",
    "The Wrinkled Shrimp",
    "The Grim Goblin",
    "The Silent Mistress",
    "The Rusty Nail",
    "The Winking Gnome",
    "The Broken Plow",
    "The Last Drop",
    "The Orcs Head",
    "The Happy Horse",
    "The Sunken Fairy",
    "The Step Right Inn",
    "The White Elephant",
    "The Road's End",
    "The Keystone Roadhouse",
    "The Old Spoke Inn",
    "The Wagon Rut Tavern",
    "The Anchor Point Pub",
    "The Ginger Brew Pub",
    "The Quiet Eaves Lodge",
    "The Copper Sword Tavern",
    "The Axe And Bramble",
    "The Mustard Seed Tavern",
    "The Bee And Bugle",
    "The Cedar Hearth Lodge",
    "The Scale And Ale",
    "The Bog And Bard",
    "The Trodden Fork",
    "The Headless Dragon",
    "The Tenth Hell",
    "The Burning Blight",
    "The Blind Beholder",
    "The Squawking Cockatrice",
    "The Bronze Hook",
    "The Toothy Grin",
    "The Don't Go Inn",
    "The Abbot and the Duchess",
    "Slum Pickens",
    "Westgate Beds and Brewery",
    "The Hungry Bear Lodge",
    "The Gobbler",
    "Ye Ol' Tavern",
    "The Mighty Bite",
    "The Banshee's Whale",
    "The Styx",
    "Forget Your Troubles",
    "Hag's End",
    "The Emerald Wyrm",
    "The Seven Drunken Knights",
    "The Frisky Fairy",
    "The Staggering Paladin",
    "The Gutted Fish",
    "The Peckish Pixie",
    "The Broken Drum",
    "Pints and Potatoes",
    "The Thirsty Troll",
    "The Mule and The Mare",
    "The Chieftain and The Prince",
    "The Serpent and The Virgin",
    "Hag's Head Inn",
    "The Molly Waggler",
    "The Olive Branch",
    "The Artful Lodger",
    "Coppershiner's",
    "Gravida's Glow",
    "The High Mandolin",
    "The Rare Lady",
    "The Amber Casks",
    "The Steamy Farmer",
    "The Drunk Duck",
    "The Camel's Hump",
    "The Seaman's Reign",
    "The Fermented Badger",
    "The Salty Scuffer",
    "New Beginnings",
    "The Good Knight's Rest",
    "The Laughing Ogre",
    "Sleepless Scholar's Inn",
    "Blackeyed Pete's R&R",
    "The Lost Road Inn",
    "The Bronze Buckle",
    "The Salty Seadog",
    "The Gnashing Gnoll"
  ],

  jobBoardQuests: [
    "Wanted Dead or Alive – Bonecrusher, Orc Chieftain to the south! Warning: very heavily armed and dangerous. Has many henchmen. Reward: 1,000gp",
    "Missing: a large turtle named Hubert who has escaped from the Caster's School of Polymorphing. Please return if found!",
    "Chicken Wrangler Needed! Some jerks smashed my coop and now 100 chickens are loose. 1GP/chicken to return them, no questions asked.",
    "Need men to form a small honour garrison for the banquet I am holding in my manor. Important people are involved, so discretion is mandatory. 200GP per person.",
    "The book store has a shipment of rare books coming in and needs people to help unload them. Will pay 100 gold per person.",
    "Exterminator needed: I've got a mess of rats in my basement. Bring me 10 rat tails in return for payment.",
    "Strong Swimmer Needed! My simpleton apprentice left my ore cart unattended on the bridge and the blasted thing tumbled into the river!",
    "Sick Grandmother: My grandmother is sick and needs a shipment of medicine. Our normal courier has gone missing.",
    "Squirrel Hunting: A squirrel has been seen in town stealing jewelry from citizens. They need to be captured or killed.",
    "Earrings Stolen: My wagon was robbed by bandits in the eastern forest. Among the items taken were heirloom earrings.",
    "TEST SUBJECT NEEDED! We at the Barrington Bakery are looking for subjects to test out our new magical breads.",
    "Lost Arrow: While practicing with a bow, my son lost a trophy arrow in the forbidden forest. Please retrieve this arrow.",
    "Goblin encampment: A goblin encampment has appeared in the Southern part of town. Find out what they're doing.",
    "Wandering Skeleton: Wandering Skeleton seen on the outskirts of town. It appears armed with a sword, shield and horned helmet.",
    "Help! Local bard needs assistance creating a list of 100 dirty jobs no one wants to do.",
    "Local mine looking for adventurers to clear out an infestation of giant spiders.",
    "Merchant caravan needs guards for journey through the Darkwood Forest. Pay: 50gp each.",
    "Strange lights seen in the old cemetery at night. Investigate and report findings. 75gp reward.",
    "Local farmer's livestock keeps disappearing. Track down the culprit. 100gp reward.",
    "Wanted: Brave souls to explore the ruins of Castle Shadowmere. Treasure split evenly.",
    "Missing person: Local herbalist hasn't been seen in three days. Last seen heading to the swamp.",
    "Bounty: Bandit leader 'Scarface' wanted for highway robbery. 500gp alive, 250gp dead.",
    "Help needed clearing blocked mountain pass. Pays 25gp per day plus meals.",
    "Escort mission: Noble's daughter needs safe passage to the capital. 200gp total.",
    "Strange noises coming from the abandoned windmill. Investigate for 50gp reward."
  ],

  dungeonLocations: [
    "An underground river",
    "Within a river dam",
    "Amid the rubble of a ruined citadel",
    "Below a graveyard",
    "In an insane asylum",
    "Inside an ice floe",
    "In another dimension/demiplane",
    "Within earthquake-plagued caverns",
    "In a hollow mountain",
    "Deep in a desert of shifting tunnels",
    "Abutting to a secret escape route",
    "In a pyramid",
    "Below a mausoleum",
    "Within a museum",
    "Under a castle",
    "Part of a menagerie",
    "In a lighthouse",
    "Under a tower",
    "In a prison",
    "Within a cathedral",
    "Under the docks",
    "In the sewers",
    "Amid an underground canal",
    "Built into an arena",
    "Part of forgotten labyrinth",
    "Connecting to a beast's den",
    "Under a tavern",
    "In a cliff village",
    "Inside a giant tree",
    "Part of a frozen city",
    "Inside a painting",
    "In a gigantic statue",
    "Under a roc nest",
    "Within a sunken ruin",
    "Hidden inside a giant egg",
    "Formed within a massive fossil",
    "Inside a crashed space vessel",
    "Grown within a deity's corpse",
    "On an island in a volcano",
    "Inside a moon, star, or another planet"
  ],

  dungeonTypes: [
    "A hedge maze",
    "A riverboat",
    "A wizard's tomb",
    "A bandit lair",
    "A vast former mine now long abandoned",
    "An abandoned casino",
    "An old theater",
    "Fog-shrouded dungeon that traps the PCs",
    "Chambers where gravity regularly reverses",
    "Moving clockwork dungeon",
    "Incredibly narrow limestone gorges",
    "Planes linked by portals",
    "The belly of a ship-swallowing sea creature",
    "A perilous bog and quicksand-filled mire",
    "A slavers' headquarters",
    "A giant tree riddled with many crevices and hollows",
    "A melting iceberg",
    "A monster infested palace of glass",
    "A slowly flooding dungeon",
    "The afterlife",
    "A dream",
    "A nightmare",
    "An iron obelisk of great size",
    "A floating bog containing sunken tombs",
    "An evil giant's castle",
    "A floating castle that appears only at night",
    "A graveyard of giant skeletons",
    "An undead town where life goes on",
    "The massive skull of an ancient dragon",
    "A tangled forest of thorny trees"
  ],

  rumors: [
    "They say the old mill is haunted by the ghost of the previous miller.",
    "The blacksmith's new apprentice is actually a wanted criminal in disguise.",
    "Dragons have been spotted flying over the mountains to the north.",
    "The mayor has been acting strange ever since his trip to the capital.",
    "There's treasure buried beneath the old oak tree in the town square.",
    "The local wizard has been buying unusual amounts of sulfur lately.",
    "Goblins have taken over the abandoned mine to the east.",
    "A traveling merchant is selling cursed items to unsuspecting villagers.",
    "The innkeeper waters down the ale but keeps the strong stuff for himself.",
    "Strange lights appear in the forest every full moon.",
    "The guard captain takes bribes to look the other way.",
    "The baker's bread has been making people see visions.",
    "A secret cult meets in the basement of the general store.",
    "The old hermit in the hills used to be a powerful archmage.",
    "The king's advisor is actually a doppelganger.",
    "A portal to another realm opens in the lake during thunderstorms.",
    "The local noble family made a pact with demons generations ago.",
    "The temple's relics are actually fakes - the real ones were stolen years ago.",
    "Werewolves have infiltrated the town guard.",
    "The town was built on an ancient burial ground."
  ],

  curses: [
    "Midas Curse: Everything you touch turns to gold... including food and loved ones.",
    "Curse of Tongues: You can only speak in languages you don't understand.",
    "Sleepwalker's Bane: You cannot sleep unless you are in mortal danger.",
    "The Glutton's Curse: You are never satisfied, no matter how much you eat.",
    "Curse of Echoes: Everyone hears your thoughts spoken aloud.",
    "The Wanderer's Curse: You cannot stay in one place for more than a day.",
    "Curse of the Forgotten: No one remembers you after you leave their sight.",
    "The Miser's Bane: Any gold you touch turns to copper.",
    "Curse of Truth: You cannot tell lies, even white lies.",
    "The Coward's Mark: You feel overwhelming fear at the sight of blood.",
    "Curse of Silence: You cannot speak above a whisper.",
    "The Unlucky Charm: All nearby allies have disadvantage on saving throws.",
    "Curse of Obsession: You become fixated on collecting one specific item.",
    "The Mirror's Curse: Your reflection acts independently and malevolently.",
    "Curse of Aging: You age one year for every day that passes.",
    "The Bleeding Curse: Wounds you receive never fully heal.",
    "Curse of Attraction: All hostile creatures target you first.",
    "The Gambler's Bane: You must accept any bet or wager offered to you.",
    "Curse of the Moon: You transform into a beast during full moons.",
    "The Drunkard's Curse: All water tastes like strong alcohol to you."
  ],

  diseases: [
    "Blinding Sickness: Pain grips the creature's mind, and its eyes turn milky white. The creature has disadvantage on Wisdom checks and Wisdom saving throws and is blinded.",
    "Filth Fever: A raging fever sweeps through the creature's body. The creature has disadvantage on Strength checks, Strength saving throws, and attack rolls that use Strength.",
    "Flesh Rot: The creature's flesh decays. The creature has disadvantage on Charisma checks and vulnerability to all damage.",
    "Mindfire: The creature's mind becomes feverish. The creature has disadvantage on Intelligence checks and Intelligence saving throws, and the creature behaves as if under a confusion spell.",
    "Seizure: The creature is overcome with shaking. The creature has disadvantage on Dexterity checks, Dexterity saving throws, and attack rolls that use Dexterity.",
    "Sewer Plague: Victim suffers painful intestinal cramps and loses 1d4 Constitution per day until cured.",
    "Sight Rot: Creature's eyes turn bloodshot and vision dims. -1 penalty to attack rolls and sight-based checks per day until cured or blinded.",
    "Cackle Fever: Symptoms include fever and disorientation. Victim must make saves or burst into fits of laughter.",
    "The Shakes: Uncontrollable trembling makes fine motor control impossible. Disadvantage on Dexterity checks.",
    "Moon Frenzy: Victim becomes aggressive and violent during full moons."
  ],

  insanityEffects: [
    "The afflicted thinks every other creature is more powerful than it.",
    "The afflicted thinks its power became overwhelming and rarely attacks.",
    "The afflicted realizes they are in a game controlled by gods.",
    "The afflicted suffers from extreme paranoia - all creatures seem hostile.",
    "Memory issues: Roll d4 when remembering. On 1, forgets everything about it.",
    "Bipolar: Every 1d20 hours, roll 1d10. Even = friendly, Odd = aggressive.",
    "Conspiracy theorist: Everything is a conspiracy.",
    "Develops pathological hatred of ducks.",
    "Autocannibalism: Finds own flesh delicious.",
    "Hears constant sound of rolling dice.",
    "Hears grandmother's voice telling them to kill people.",
    "Cannot feel safe alone, panics without companions.",
    "Develops fear of the number 13.",
    "Develops a drinking problem.",
    "Believes they switched bodies with first person they see each day.",
    "Cannot comprehend words unless spoken backwards.",
    "Unnatural obsession with black hair.",
    "Believes they can cast Wish at will.",
    "Refuses to wear armor, believing skin is incredibly durable.",
    "Speaks only in third person."
  ],

  injuries: [
    "Lose 1d4 teeth upon reaching 0 HP.",
    "Break your left leg.",
    "Hit head on the way down: -1 INT.",
    "Lung collapses: 1 point of exhaustion, athletics causes another.",
    "Vision problems: -5 to all ranged attack rolls.",
    "Nerves are shot: Feel no pain for 1d4+3 days, DM tracks HP secretly.",
    "Suffer from flashbacks.",
    "1d4+1 levels of exhaustion.",
    "Nasty facial scar: -1 Charisma.",
    "Armor has hole: -1 AC.",
    "Confused for 1d4 hours upon waking.",
    "Metal shrapnel in heart: -1 to Death Saving Throws.",
    "Permanent limp: -5 ft walking speed.",
    "Hands crushed: Lose proficiency with Sleight of Hand.",
    "Minor amnesia: Forget one cantrip or language.",
    "Body in pain: Next Long Rest counts as Short Rest.",
    "Permanent hearing damage in one ear.",
    "Traumatic nightmares: Roll d8 each night, on 1 no sleep benefits."
  ],

  thriftStoreItems: [
    "Chip Plate Set: A halfling crafted china set with silver utensils.",
    "Urn of Dwarven Remains: Exactly what you think it is.",
    "Slipbane Crutches: Magically enchanted crutches that adhere to any surface.",
    "Merlin's Travelling 'Tiques: Miniature furniture that enlarges with a wand.",
    "Griffon Feather Head Dress: From a masquerade party. Griffons are endangered!",
    "The Gorge Four-mon Grill: Portable sandwich maker with portal to Fire Plane.",
    "Half a wizard staff. Neither half can exist on the same plane.",
    "A 'silver' sword that's actually just shiny steel.",
    "Russian nesting dolls with animated, mouthing women inside.",
    "A crown made of real (or fake) dragon teeth.",
    "A magical broom that laughs when you punch someone with it.",
    "A stuffed real horse, formerly used as an armor stand.",
    "A magical glass sphere that shows wrong people when asked.",
    "A breastplate with a bull-horn-sized hole over the heart.",
    "A bag of holding that only holds 5 items.",
    "An enchanted knife with a long-forgotten enchantment.",
    "A small bag of portable wolves.",
    "An ornate clock counting down to... something.",
    "A snowglobe containing a perfect replica of the shop and everyone in it.",
    "Old, faded copies of 'Beholder's Digest' magazine."
  ],

  names: {
    humanMale: ["Anlow", "Arando", "Bram", "Cale", "Dalkon", "Daylen", "Dodd", "Dungarth", "Dyrk", "Eandro", "Falken", "Feck", "Fenton", "Gryphero", "Hagar", "Jeras", "Krynt", "Lavant", "Leyten", "Madian"],
    humanFemale: ["Azura", "Brey", "Hallan", "Kasaki", "Lorelei", "Mirabel", "Pharana", "Remora", "Rosalyn", "Sachil", "Saidi", "Tanika", "Tura", "Tylsa", "Vencia", "Xandrilla"],
    humanLast: ["Arkalis", "Armanci", "Bilger", "Blackstrand", "Brightwater", "Carnavon", "Coldshore", "Coyle", "Cresthill", "Daargen", "Falck", "Grantham", "Graylock", "Moonridge", "Oakenheart"],
    elfMale: ["Alarcion", "Alathar", "Ariandar", "Arromar", "Borel", "Carydion", "Elgoth", "Farlien", "Ferel", "Gaerlan", "Kaelthorn", "Laethan", "Lorifir", "Morian", "Tevior"],
    elfFemale: ["Aryllan", "Atalya", "Ayrthwil", "Irva", "Lyfalia", "Ronefel", "Thirya", "Velene", "Venefiq", "Zereni"],
    dwarfMale: ["Agaro", "Arnan", "Baelnar", "Balfam", "Bariken", "Darkûl", "Dolmen", "Dyrnar", "Erag", "Ferrek", "Glint", "Haeltar", "Korlag", "Krag", "Thorin"],
    dwarfFemale: ["Beyla", "Fenryl", "Grenenzel", "Krystolari", "Lokara", "Lurka", "Marnia", "Praxana", "Rokel", "Vauldra"],
    halflingMale: ["Arthan", "Carvin", "Corby", "Cullen", "Egen", "Ernest", "Heron", "Jeryl", "Keffen", "Leskyn", "Quarrel", "Rabbit", "Titch", "Tuck", "Whim"],
    halflingFemale: ["Caliope", "Emily", "Piper", "Rixi", "Sabretha", "Teg", "Tilly", "Toira", "Vexia", "Vil", "Zanthe"]
  },

  shopTypes: [
    "Blacksmith - Weapons and armor",
    "Apothecary - Potions and remedies",
    "General Store - Adventuring supplies",
    "Jeweler - Gems and fine jewelry",
    "Tailor - Clothing and cloaks",
    "Bookshop - Tomes and scrolls",
    "Magic Shop - Arcane items",
    "Butcher - Meats and rations",
    "Baker - Breads and pastries",
    "Cartographer - Maps and charts",
    "Herbalist - Plants and ingredients",
    "Tanner - Leather goods",
    "Carpenter - Wood items and furniture",
    "Stables - Horses and mounts",
    "Fletcher - Arrows and bows",
    "Glassblower - Vials and decorative glass",
    "Chandler - Candles and wax",
    "Cobbler - Boots and shoes",
    "Armorer - Specialized armor",
    "Alchemist - Exotic concoctions"
  ],

  magicItemPricing: {
    common: "1d6+1 × 10 gp",
    uncommon: "1d6 × 100 gp",
    rare: "2d10 × 1,000 gp",
    veryRare: "(1d4+1) × 10,000 gp",
    legendary: "2d6 × 25,000 gp",
    note: "Halved for consumable items like potions or scrolls"
  },

  travelPace: [
    { pace: "Fast", perMinute: "400 feet", perHour: "4 miles", perDay: "30 miles", effect: "-5 to passive Perception" },
    { pace: "Normal", perMinute: "300 feet", perHour: "3 miles", perDay: "24 miles", effect: "—" },
    { pace: "Slow", perMinute: "200 feet", perHour: "2 miles", perDay: "18 miles", effect: "Able to use Stealth" }
  ],

  services: [
    { service: "Coach cab (between towns)", cost: "3 cp per mile" },
    { service: "Coach cab (within city)", cost: "1 cp" },
    { service: "Hireling (skilled)", cost: "2 gp per day" },
    { service: "Hireling (untrained)", cost: "2 sp per day" },
    { service: "Messenger", cost: "2 cp per mile" },
    { service: "Road or gate toll", cost: "1 cp" },
    { service: "Ship's passage", cost: "1 sp per mile" }
  ],

  difficultyClasses: [
    { difficulty: "Very Easy", dc: 5 },
    { difficulty: "Easy", dc: 10 },
    { difficulty: "Medium", dc: 15 },
    { difficulty: "Hard", dc: 20 },
    { difficulty: "Very Hard", dc: 25 },
    { difficulty: "Nearly Impossible", dc: 30 }
  ]
};

export default dmScreenData;
